import mainConfig from "./configLoader.js";
import React, { Component, useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
import Header from "./header/Header";
import Sidebar from "./sidebar/Sidebar";
import SCMap from "./map/SCMap";
import LegendApp from "./legend/App";
import LayerInfoApp from "./layerInfo/App";

import "./helpers/SC.scss";

import * as helpers from "./helpers/helpers";
import LoadingScreen from "./helpers/LoadingScreen.jsx";
import ReactGA from "react-ga";
import packageJson from "../package.json";

// if (process.env.REACT_APP_ENV !== "production") console.log = function() {};

window.config = mainConfig;
//if (process.env.REACT_APP_DISPLAY_LOG !== false) console.log = function() {};


const enableAnalytics = helpers.getURLParameter("ANALYTICS") !== "off";
if (mainConfig.googleAnalyticsID !== undefined && mainConfig.googleAnalyticsID !== "" && enableAnalytics) {
  ReactGA.initialize(mainConfig.googleAnalyticsID);
  ReactGA.pageview(window.location.pathname + window.location.search);
}
let kravina="";
class App extends Component {  
  setControlPreferences() {    
    const localMapControls = helpers.getItemsFromStorage("Map Control Settings");
    const ThemeContext = React.createContext('light');
    if (localMapControls !== undefined) window.mapControls = localMapControls;
    else window.mapControls = mainConfig.controls;
  }
  componentWillMount() {
    this.setState({magda:"xxx"});
    window.app = packageJson.name;
    window.homepage = packageJson.homepage;
    window.version = packageJson.version;
    this.setControlPreferences();
  }
  akozeuz (value) {
    kravina = value;
  }
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/legend">
            <LegendApp />
          </Route>
          <Route path="/layerInfo">
            <LayerInfoApp />
          </Route>
          <Route path="/public">
            <MapApp akozeuz = {this.akozeuz}/>
          </Route>
          <Route path="/">
            <MapApp akozeuz = {this.akozeuz}/>
          </Route>
        </Switch>
      </Router>
    );
  }
}

function MapApp(props) {    
  const [mapLoading, setMapLoading] = useState(true);
  const [sidebarLoading, setSidebarLoading] = useState(true);
  const [headerLoading, setHeaderLoading] = useState(true);
  const [langValue] = useState(true);
  let [copyr, setasdf] = useState(true);
  /*function setasdf (asdf) {
    console.log(asdf);
  }*/
  // LISTEN FOR MAP TO MOUNT
  const handleLanguage = (langValue => {      
    props.akozeuz(langValue);
     //this.setState({magda:langValue})  
   })
  window.emitter.addListener("mapLoaded", () => setMapLoading(false));
  window.emitter.addListener("mapLoading", () => setMapLoading(true));
  // LISTEN FOR SIDEBAR TO MOUNT
  window.emitter.addListener("sidebarLoaded", () => setSidebarLoading(false));
  // LISTEN FOR HEADER TO MOUNT
  window.emitter.addListener("headerLoaded", () => setHeaderLoading(false));
  const changeIcon = (icon) => {
    var link = document.getElementById("favicon");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      link.id = "favicon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    let urlArray = link.href.split("/");
    urlArray.pop();
    icon = `${urlArray.join("/")}/${icon}`;
    link.href = icon;
  };
  useEffect(() => {
    window.app = packageJson.name;
    window.homepage = packageJson.homepage;
    window.version = packageJson.version;
    helpers.loadConfig(() => {            
      document.title = window.config.title;
      if (window.config.favicon) changeIcon(window.config.favicon);
      helpers.addIsLoaded("settings");
      if (window.config.default_theme !== undefined) window.emitter.emit("activateSidebarItem", window.config.default_theme, "themes");
      if (window.config.default_tool !== undefined) window.emitter.emit("activateSidebarItem", window.config.default_tool, "tools");
    });
  }, []);
  /*function asdf (data) {
    console.log("data: " + data);
    //this.props.asdf(data);
  };*/

  return (
    <div>
      <div id="portal-root" />
      <LoadingScreen visible={mapLoading || sidebarLoading || headerLoading} backgroundColor={"#3498db"} />
      <Header mapLoading={mapLoading} sidebarLoading={sidebarLoading} />
      <Sidebar mapLoading={mapLoading} headerLoading={headerLoading} copyr = {props.akozeuz}/>
      <SCMap sidebarLoading={sidebarLoading} headerLoading={headerLoading} handleLanguage={handleLanguage} />
    </div>
  );
}
export default App;
